export default "__VITE_PUBLIC_ASSET__45060273__"